import { ChecklistSectionDocuments, ChecklistDocuments, GuaranteeType } from "@interfaces/catalogs";

export const normalizeChecklistSectionDocuments = (value: unknown): ChecklistSectionDocuments => {
  if (!Array.isArray(value)) {
    return [];
  }

  return value.map((item, index) => ({
    order: typeof item?.order === "number" ? item.order : index + 1,
    title: typeof item?.title === "string" ? item.title : "",
    tooltip: typeof item?.tooltip === "string" ? item.tooltip : undefined,
    documents: Array.isArray(item?.documents)
      ? item.documents.filter((document: unknown) => typeof document === "string")
      : [],
    guarantee_type_code: typeof item?.guarantee_type_code === "string" ? item.guarantee_type_code : undefined,
  }));
};

export const normalizeChecklistDocuments = (value: unknown): ChecklistDocuments => {
  if (!Array.isArray(value)) {
    return [];
  }

  return value.filter((item): item is string => typeof item === "string");
};

export const filterChecklistByGuarantee = (
  documents: ChecklistSectionDocuments,
  guarantee_type: GuaranteeType | undefined,
) => {
  const filtered_documents = documents.filter((item) => {
    if (item.guarantee_type_code) {
      if (item.guarantee_type_code === guarantee_type?.code) {
        return true;
      }
      return false;
    }
    return true;
  });
  return filtered_documents;
};
